import './App.css';
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Login from './Components/Screens/Login/Login.jsx';
import ProtectedRoute from './Components/Protected Route/ProtectedRoute';
import RoleProtectedRoute from './Components/Protected Route/RoleProtectedRoute'; // Import the new component
import InternalServerError from "./Components/Errors Handling/Error 500/InternalServerError.jsx";
import Error404 from "./Components/Errors Handling/Error 404/Error404.jsx";
import Layout from './Components/layout/Layout.jsx';
import Dashboard from './Components/Screens/Dashboard/Dashboard.jsx';
import Clinics from './Components/Screens/Clinics/Clinics.jsx';
import WorkingDaysPage from './Components/Screens/WorkingDays/WorkingDays.jsx';

import { UserSubscription } from './Components/Screens/Plans/Plans.jsx';
import InvitationsScreen from './Components/Screens/InvitationsScreen/SendInvitationScreen.jsx';
import DoctorsScreen from './Components/Screens/Doctors/Doctors.jsx';
import BookingsScreen from './Components/Screens/BookingsScreen/BookingsScreen.jsx';
import PatientsList from './Components/Screens/PatientsList/PatientsList.jsx';
import PatientDetails from './Components/Screens/PatientDetails/PatientDetails.jsx';
import Insights from './Components/Screens/Insights/Insights.jsx';
import AdsScreen from './Components/Screens/AdsScreen/AdsScreen.jsx';
import NewsScreen from './Components/Screens/News/News.jsx';
import PackagesManagement from './Components/Screens/PackagesScreen/PackageScreen.jsx';
import ServicesScreen from './Components/Screens/Services/Services.jsx';
import BlogScreen from './Components/Screens/BlogsScreen/BlogsScreen.jsx';
import ContactScreen from './Components/Screens/Contact/Contact.jsx';
import SpecialistBookingsScreen from './Components/Screens/SpecialistBookingsScreen/SpecialistBookingsScreen.jsx';
import EmployeeManagement from './Components/Screens/EmployeeManagement/EmployeesManagement.jsx';
import SuppliersScreen from './Components/Screens/Suppliers/Suppliers.jsx';
import MaintenanceCompaniesScreen from './Components/Screens/MaintainaceCompanies/MaintenanceCompanies.jsx';
import EquipmentsScreen from './Components/Screens/EquipMents/Equipments.jsx';
import FacilitiesManagement from './Components/Screens/Facilities/Facilities.jsx';
import FacilityDetails from './Components/Screens/FacilityDetails/FacilityDetails.jsx';
import OvrScreen from './Components/Screens/OVR/OVR.jsx';
import ExternalConsultantsManagement from './Components/Screens/ExternalConsaltants/ExternalConsaltant.jsx';
import ContractsScreen from './Components/Screens/Contracts/Contracts.jsx';
import BookingsAndSessions from './Components/Screens/BookingsAndSessions/BookingsAndSessions.jsx';
import ExcuseManagement from './Components/Screens/Excuse/ExcuseManagements.jsx';
import ClinicsPerformance from './Components/Screens/ClinicsPerformance/ClinicsPerformance.jsx';
import VacationsScreen from './Components/Screens/VacationsScreen/VacationsScreen.jsx';
import Seceretary from './Components/Screens/Seceretary/Seceretary.jsx';
import QrGeneration from './Components/Screens/QrGeneration/QrGeneration.jsx';
import QrScanner from './Components/Screens/QrScanner/QrScanner.jsx';
import ReviewQrGeneration from './Components/Screens/ReviewQrGeneration/ReviewQrGeneration.jsx';
import EditCenterScreen from './Components/Screens/EditCenterScreen/EditCenterScreen.jsx';
import Specializations from './Components/Screens/Specializations/Specializations.jsx';
import ServicesAndPackages from './Components/Screens/ServicesAndPackages/ServicesAndPackages.jsx';
import MarketingAndContent from './Components/Screens/MarketingAndContent/MarketingAndContent.jsx';
import AnalysisScreen from './Components/Screens/AnalysisScreen/AnalysisScreen.jsx';
import CenterManagement from './Components/Screens/CenterManagement/CenterManagement.jsx';
import Staff from './Components/Screens/Staff/Staff.jsx';
import HumanResources from './Components/Screens/HumanResourses/HumanResourses.jsx';
import CouponsScreen from './Components/Screens/CouponsScreen/CouponsScreen.jsx';
import ServicesAnalysis from './Components/Screens/ServicesAnalysis/ServicesAnalysis.jsx';


function App() {

  const routers = createBrowserRouter([
    { index: true, element: <Login /> },
    { path: "login", element: <Login /> },

    {
      path: '/', element: <ProtectedRoute><Layout /></ProtectedRoute>,
      children: [
        {
          path: 'bookings',
          element: (
            <RoleProtectedRoute allowedRoles={[3, 4]}>
              <BookingsScreen />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'all-bookings',
          element: (
            <RoleProtectedRoute allowedRoles={[3, 4,7]}>
              <BookingsAndSessions />
            </RoleProtectedRoute>
          )
        },
           {
          path: 'specialist-bookings-screen',
          element: (
            <RoleProtectedRoute allowedRoles={[ 3,4]}>
              <SpecialistBookingsScreen />
            </RoleProtectedRoute>
          )
        },
        { path: 'patients/:id', element: <PatientDetails /> },

        
        {
          path: 'dashboard',
          element: (
            <RoleProtectedRoute allowedRoles={[3]}>
              <AnalysisScreen />
            </RoleProtectedRoute>
          )
        },
        
        {
          path: 'dashboard-analysis',
          element: (
            <RoleProtectedRoute allowedRoles={[7]}>
              <Dashboard />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'performance-analysis',
          element: (
            <RoleProtectedRoute allowedRoles={[7]}>
              <ClinicsPerformance />
            </RoleProtectedRoute>
          )
        },
        
        {
          path: 'coupons',
          element: (
            <RoleProtectedRoute allowedRoles={[3]}>
              <CouponsScreen />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'clinics',
          element: (
            <RoleProtectedRoute allowedRoles={[3,4]}>
              <Clinics />
            </RoleProtectedRoute>
          )
        },

        {
          path: 'excuse',
          element: (
            <RoleProtectedRoute allowedRoles={[3]}>
              <ExcuseManagement />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'patients',
          element: (
            <RoleProtectedRoute allowedRoles={[3,4]}>
              <PatientsList />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'ads',
          element: (
            <RoleProtectedRoute allowedRoles={[3,4]}>
              <AdsScreen />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'news',
          element: (
            <RoleProtectedRoute allowedRoles={[3,4,7]}>
              <NewsScreen />
            </RoleProtectedRoute>
          )
        },
        { 
          path: 'insights', 
          element: (
            <RoleProtectedRoute allowedRoles={[3,7]}>
              <Insights />
            </RoleProtectedRoute>
          ) 
        },
        {
          path: 'schedule',
          element: (
            <RoleProtectedRoute allowedRoles={[3,4]}>
              <WorkingDaysPage />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'send-invite',
          element: (
            <RoleProtectedRoute allowedRoles={[3]}>
              <InvitationsScreen />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'doctors',
          element: (
            <RoleProtectedRoute allowedRoles={[3,4,7]}>
              <DoctorsScreen />
            </RoleProtectedRoute>
          )
        },
        
      
        {
          path: 'external-consultant',
          element: (
            <RoleProtectedRoute allowedRoles={[4]}>
              <ExternalConsultantsManagement />
            </RoleProtectedRoute>
          )
        },
      
        {
          path: 'employees',
          element: (
            <RoleProtectedRoute allowedRoles={[3]}>
              <Staff />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'vacations',
          element: (
            <RoleProtectedRoute allowedRoles={[3]}>
              <VacationsScreen />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'human-resourses',
          element: (
            <RoleProtectedRoute allowedRoles={[3]}>
              <HumanResources />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'specializations',
          element: (
            <RoleProtectedRoute allowedRoles={[3]}>
              <Specializations />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'suppliers',
          element: (
            <RoleProtectedRoute allowedRoles={[3]}>
              <ContractsScreen />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'companies',
          element: (
            <RoleProtectedRoute allowedRoles={[3,7]}>
              <MaintenanceCompaniesScreen />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'Equipments',
          element: (
            <RoleProtectedRoute allowedRoles={[3,7]}>
              <EquipmentsScreen />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'facilities',
          element: (
            <RoleProtectedRoute allowedRoles={[3,7]}>
              <FacilitiesManagement />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'management',
          element: (
            <RoleProtectedRoute allowedRoles={[3]}>
              <CenterManagement />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'ovr',
          element: (
            <RoleProtectedRoute allowedRoles={[4,3]}>
              <OvrScreen />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'clinics-performance',
          element: (
            <RoleProtectedRoute allowedRoles={[4,3,7]}>
              <ClinicsPerformance />
            </RoleProtectedRoute>
          )
        },
        {
          path: '/facilities/:id',
          element: (
            <RoleProtectedRoute allowedRoles={[3]}>
              <FacilityDetails />
            </RoleProtectedRoute>
          )
        },
        
        // { 
        //   path: 'form-builder', 
        //   element: (
        //     <RoleProtectedRoute allowedRoles={[3]}>
        //       <CreateBookingForm />
        //     </RoleProtectedRoute>
        //   ) 
        // },


        { 
          path: 'services-packages', 
          element: (
            <RoleProtectedRoute allowedRoles={[3,4,7]}>
              <ServicesAndPackages />
            </RoleProtectedRoute>
          ) 
        },
        { 
          path: 'services-analysis', 
          element: (
            <RoleProtectedRoute allowedRoles={[3,7]}>
              <ServicesAnalysis />
            </RoleProtectedRoute>
          ) 
        },
        { 
          path: 'Secertaries', 
          element: (
            <RoleProtectedRoute allowedRoles={[3]}>
              <Seceretary />
            </RoleProtectedRoute>
          ) 
        },
        { 
          path: 'QrGeneration', 
          element: (
            <RoleProtectedRoute allowedRoles={[4]}>
              <QrGeneration />
            </RoleProtectedRoute>
          ) 
        },
        { 
          path: 'scanQr', 
          element: (
            <RoleProtectedRoute allowedRoles={[3,4,6]}>
              <QrScanner />
            </RoleProtectedRoute>
          ) 
        },
        { 
          path: 'Blogs', 
          element: (
            <RoleProtectedRoute allowedRoles={[3,4]}>
              <BlogScreen />
            </RoleProtectedRoute>
          ) 
        },
        { 
          path: 'marketing', 
          element: (
            <RoleProtectedRoute allowedRoles={[3,4,7]}>
              <MarketingAndContent />
            </RoleProtectedRoute>
          ) 
        },
        { 
          path: 'contact', 
          element: (
            <RoleProtectedRoute allowedRoles={[3,4,7]}>
              <ContactScreen />
            </RoleProtectedRoute>
          ) 
        },
        {
          path: 'sub',
          element: (
            <RoleProtectedRoute allowedRoles={[3]}>
              <UserSubscription />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'reviewQr',
          element: (
            <RoleProtectedRoute allowedRoles={[3,4]}>
              <ReviewQrGeneration />
            </RoleProtectedRoute>
          )
        },
        {
          path: 'edit-center',
          element: (
            <RoleProtectedRoute allowedRoles={[3,4,7]}>
              <EditCenterScreen />
            </RoleProtectedRoute>
          )
        },

        // Error pages - accessible to all authenticated users
        { path: 'server-error', element: <InternalServerError /> },
        { path: 'not-found', element: <Error404 /> },
        { path: '*', element: <Error404 /> }
      ]
    },
  ]);

  return <>
    <RouterProvider router={routers} />
  </>
}

export default App;